import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-info-modal',
  imports: [],
  templateUrl: './info-modal.html',
  styleUrl: './info-modal.scss'
})
export class InfoModal {
  isModalOpen: boolean = false;
  @Input() message: string = 'Are you sure you want to delete this item?';
  @Input() title: string = 'Delete Item';
  @Input() buttonText: string = 'Confirm';
  @Input() type: 'confirm' | 'info' = 'confirm';
  @Output() onClose = new EventEmitter<void>();

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  close() {
    this.onClose.emit();
    this.closeModal();
  }
}
